// extracted by mini-css-extract-plugin
export default {"root":"classes_root__kEu6s","spin":"classes_spin__JgD1S"};